<div class="generate-image-uploader-container">
  <!-- <pre>{{fileList?.length ? fileList[0] : [] | json}}</pre> -->
  <!-- <pre>{{containerImage}}</pre> -->
  <!-- Show uploaded Image preview and textbox if there is an uploaded image -->
  <div *ngIf="previewImage"
       class="ai-generate-uploaded-image-container">
    <button nz-button
            nz-tooltip="Remove Image"
            nzSize="small"
            class="delete-uploaded-image-button"
            (click)="onClickDeleteUploadedImage($event)">
      <i class="fa-regular fa-trash"></i>
    </button>
    <img [src]="previewImage"
         class="ai-generate-uploaded-image"
         alt="Uploaded Image" />
    <textarea class="add-component-with-ai-textarea"
              rows="3"
              [(ngModel)]="componentDefinitionDescription"
              (keydown)="onKeyDownComponentDefinitionTextArea($event)"
              (click)="onClickComponentDefinitionTextArea($event)"
              (focus)="onFocusComponentDefinitionTextArea($event)"
              (blur)="onBlurComponentDefinitionTextArea($event)"
              [placeholder]="textAreaPlaceholder"></textarea>
    <button nz-button
            nz-tooltip="Generate the content of this container with AI Assistant"
            nzSize="small"
            class="ai-button"
            (click)="onClickGenerateComponent($event)">
      <i class="fa-solid fa-sparkles ai-icon"></i>
      &nbsp;
      Generate with Assistant
    </button>
  </div>
  <nz-upload nzListType="picture-card"
             class="generate-image-uploader"
             nzLimit="1"
             [(nzFileList)]="fileList"
             [nzShowUploadList]="false"
             [nzShowButton]="!fileList.length"
             [nzPreview]="handlePreview"
             (nzChange)="handleChange($event)">
    <div class="upload-container">

      <div class="ai-add-component-container">
        <!-- Show a textbox if there isn't an uploaded image -->
        <div *ngIf="!fileList.length"
             class="ai-add-component-description-container">
          <!-- description -->
          <textarea class="add-component-with-ai-textarea"
                    rows="3"
                    [(ngModel)]="componentDefinitionDescription"
                    (keydown)="onKeyDownComponentDefinitionTextArea($event)"
                    (click)="onClickComponentDefinitionTextArea($event)"
                    (focus)="onFocusComponentDefinitionTextArea($event)"
                    (blur)="onBlurComponentDefinitionTextArea($event)"
                    [placeholder]="textAreaPlaceholder"></textarea>

          <button nz-button
                  nz-tooltip="Upload an image to generate a component with Assistant"
                  nzSize="small"
                  class="upload-button"
                  (click)="onClickUploadButton($event)">
            <i class="fa-regular fa-image"></i><br>Upload
          </button>
        </div>

        <!-- upload instructions -->
        <!-- <div class="upload-instructions">
          Drag and drop an image here, or click to upload one. You can also describe what you want in the textbox below
          to generate a component using AI.<br>
          Rapider AI will create the component based on your description and the uploaded image within this container.
        </div> -->

        <!-- button to generate the component with AI -->
        <button nz-button
                nz-tooltip="Generate the content of this container with Assistant"
                nzSize="small"
                class="ai-button"
                (click)="onClickGenerateComponent($event)">
          <i class="fa-solid fa-sparkles ai-icon"></i>
          &nbsp;
          Generate with Assistant
        </button>
      </div>


    </div>
  </nz-upload>
  <nz-modal [nzVisible]="previewVisible"
            [nzContent]="modalContent"
            [nzFooter]="null"
            (nzOnCancel)="previewVisible = false">
    <ng-template #modalContent>
      <img [src]="previewImage"
           [ngStyle]="{ width: '100%' }" />
    </ng-template>
  </nz-modal>
</div>
